import React from 'react';
import { motion } from 'framer-motion';
import { Home, Building2, Sun, BatteryCharging, Zap, Lightbulb, ArrowRight } from 'lucide-react';
const services = [{
  title: 'RESIDENTIAL ELECTRICAL',
  description: 'From troubleshooting flickering lights to complete home rewiring. Safe, reliable, and up to code.',
  icon: Home,
  image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=600&q=80'
}, {
  title: 'COMMERCIAL ELECTRICAL',
  description: 'Keep your business running smoothly with our comprehensive commercial electrical services.',
  icon: Building2,
  image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=600&q=80'
}, {
  title: 'SOLAR INSTALLATION',
  description: 'Harness the Nevada sun. We design and install efficient solar systems for homes and businesses.',
  icon: Sun,
  image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?auto=format&fit=crop&w=600&q=80'
}, {
  title: 'EV CHARGER INSTALLATION',
  description: 'Level 2 charging stations installed safely in your garage or commercial parking lot.',
  icon: BatteryCharging,
  image: 'https://images.unsplash.com/photo-1593941707882-a5bba14938c7?auto=format&fit=crop&w=600&q=80'
}, {
  title: 'PANEL UPGRADES',
  description: "Modernize your electrical panel to handle today's power demands safely and efficiently.",
  icon: Zap,
  image: 'https://images.unsplash.com/photo-1555963966-b7ae5404b6ed?auto=format&fit=crop&w=600&q=80'
}, {
  title: 'LIGHTING SOLUTIONS',
  description: 'Custom indoor and outdoor lighting design, installation, and energy-efficient retrofits.',
  icon: Lightbulb,
  image: 'https://images.unsplash.com/photo-1565538810643-b5bdb714032a?auto=format&fit=crop&w=600&q=80'
}];
export function Services() {
  return <section id="services" className="py-24 bg-[#1f1f1f]" data-id="element-152">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-153">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-154">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 uppercase" data-id="element-155">
            OUR CORE <span className="text-[#FFD700]" data-id="element-156">SERVICES</span>
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-157">
            Whether you need a simple repair, a major upgrade, or a complete
            solar installation, our licensed experts have you covered.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-158">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group cursor-pointer rounded-2xl overflow-hidden relative min-h-[340px] flex flex-col justify-end" data-id="element-159">
              {/* Background Image */}
              <img src={service.image} alt={service.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-160" />
              {/* Dark overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#1f1f1f] via-[#1f1f1f]/70 to-transparent" data-id="element-161" />

              {/* Content */}
              <div className="relative z-10 p-8" data-id="element-162">
                <div className="w-12 h-12 bg-[#FFD700] rounded-full flex items-center justify-center mb-4" data-id="element-163">
                  <service.icon className="w-6 h-6 text-[#1f1f1f]" data-id="element-164" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2 uppercase tracking-wide" data-id="element-165">
                  {service.title}
                </h3>
                <p className="text-gray-300 text-sm mb-4 line-clamp-2" data-id="element-166">
                  {service.description}
                </p>
                <div className="flex items-center text-sm font-bold text-[#FFD700] group-hover:translate-x-2 transition-transform" data-id="element-167">
                  LEARN MORE <ArrowRight className="w-4 h-4 ml-2" data-id="element-168" />
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}